import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface SortingFieldOption {
  key: string;
  value: string;
}

export const getSortingFieldsAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetSortColumns`,
  });
};

export type SortingFieldsResponse = SortingFieldOption[];

export const fetchSortingFields = async (): Promise<SortingFieldsResponse> => {
  const response: AxiosResponse<SortingFieldsResponse> = await getSortingFieldsAPI();
  return response.data;
};
